module.exports = __webpack_public_path__ + "static/media/jetsuite_card_4.b05c460f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/jetsuite_card_4.png
// module id = 517
// module chunks = 0